import { ChangeEvent, useRef } from "react";
import axios from "axios";
import { Box, Button } from "@mui/material";
import { isFunction, isNonEmptyObject } from "@/utils";

export type UploadFileInputProps = {
  url?: string;
  text?: string;
  endIcon?: React.ReactNode;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  additionalFormData?: { [key: string]: any };
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onUploaded?: (result?: any) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onError?: (error?: any) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  sxContainer?: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  sxButton?: any;
};

const UploadFileInput: React.FC<UploadFileInputProps> = ({
  url = undefined,
  text = undefined,
  endIcon = undefined,
  additionalFormData = undefined,
  onUploaded = undefined,
  onError = undefined,
  sxContainer = undefined,
  sxButton = undefined,
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleFileChange = (e?: ChangeEvent<HTMLInputElement>) => {
    if (!url || !e?.target?.files?.length) {
      return;
    }

    const file = e?.target?.files?.[0];
    const formData = new FormData();
    formData.append("files", file);

    if (isNonEmptyObject(additionalFormData)) {
      const keys = Object.keys(additionalFormData!);
      for (let i = 0, l = keys.length; i < l; ++i) {
        formData.append(keys[i], additionalFormData![keys[i]]);
      }
    }

    if (isFunction(onUploaded)) {
      onUploaded?.(undefined);
    }

    if (isFunction(onError)) {
      onError?.(undefined);
    }

    axios
      .post(url, formData)
      .then((response) => {
        if (isFunction(onUploaded)) {
          onUploaded?.(response);
        }
      })
      .catch((error) => {
        if (isFunction(onError)) {
          onError?.(error);
        }
      })
      .finally(() => {
        if (fileInputRef?.current) {
          fileInputRef.current.value = "";
        }
      });
  };

  const handleFileUpload = () => {
    fileInputRef?.current?.click();
  };

  return (
    <Box sx={sxContainer}>
      <input
        type="file"
        ref={fileInputRef}
        onChange={handleFileChange}
        style={{ display: "none" }}
      />
      <Button onClick={handleFileUpload} endIcon={endIcon} sx={sxButton}>
        {text || "Upload"}
      </Button>
    </Box>
  );
};

UploadFileInput.displayName = "UploadFileInput";

export default UploadFileInput;
